module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }, [_c('h1', {
    staticClass: "conhead"
  }, [_vm._v("Contents")])]), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/005_List_of_Illustrations"
    }
  }, [_vm._v("Lists of Illustrations")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/006_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Map"
    }
  }, [_vm._v("Regional Maps")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/008_Chapter_1"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("1.")]), _vm._v("Historical Context: the Period of the Crusades")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/008_Chapter_1#chap1-1"
    }
  }, [_vm._v("Setting the Stage")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/008_Chapter_1#chap1-2"
    }
  }, [_vm._v("The First Generations")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/008_Chapter_1#chap1-3"
    }
  }, [_vm._v("The Age of Nūr al-Dīn and Saladin")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/008_Chapter_1#chap1-4"
    }
  }, [_vm._v("The Ayyūbid Era")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/008_Chapter_1#chap1-5"
    }
  }, [_vm._v("Early Mamlūk Rule")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/008_Chapter_1#chap1-6"
    }
  }, [_vm._v("West vs. East, Christians vs. Muslims?")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("2.")]), _vm._v("Strategy of Defence: Building and Using Fortifications")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_2#chap2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Before the Crusades")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_2#chap2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Administration")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_2#chap2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Location")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_2#chap2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tactical Use")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_2a#chap2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Defenders")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_2a#chap2-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refuge")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_2a#chap2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Planners")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("3.")]), _vm._v("Strategy of Attack: Overcoming the Obstacle of Relief")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_3#chap3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Early Opportunism")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_3#chap3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Relief Forces")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_3#chap3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Distraction")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_3#chap3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Truces")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_3#chap3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rapid Attack")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("4.")]), _vm._v("Means of Attack: Siege Weapons")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_4#chap4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Armies")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_4#chap4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Action beyond the Walls")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_4#chap4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Siege Engines")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_4a#chap4-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Naval Support")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_4a#chap4-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deception and Negotiation")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_4a#chap4-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transfer of Knowledge")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("5.")]), _vm._v("Means of Defence: the Design of Fortifications")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_5#chap5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Provisions")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_5#chap5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Walls and Towers")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-6"
    }
  }), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "VPS-6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_5#chap5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Entrances")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_5#chap5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Development")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_5#chap5-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shift in Design")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_5#chap5-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Active Defence")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_5#chap5-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Payoff")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("6.")]), _vm._v("Influences and Trends")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_6#chap6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fortifications")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_6#chap6-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trends: Distribution, Success and Duration")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Advert1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: the Siege of Acre, 1291")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Advert2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("List of Sieges")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/016_Advert3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rulers and their Reigns")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/017_Glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/018_Endnotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/019_BM1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Select Bibliography by Site")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/020_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0